const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento",
            postponed: "Adiados"
          },
          waiting: {
            title: "Aguardando atendimento"
          },
          closed: {
            title: "Finalizados hoje"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          provider: "Método de conexão",
          providerHelp:
            "Escolha como esta linha se conecta ao WhatsApp. Não pode ser alterado depois de criada.",
          providerLockedHelp:
            "O método de conexão não pode ser alterado depois que a linha é criada.",
          providerOptions: {
            wwebjs: "Padrão (recomendado) — whatsapp-web.js",
            whaileys: "Alternativo (experimental) — Baileys",
          },
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
        nameSources: {
          manual: "Editado manualmente",
          whatsapp_verified: "Nome comercial ou verificado",
          whatsapp_profile: "Perfil do WhatsApp",
          whatsapp_address_book: "Agenda do WhatsApp",
          provisional: "Nome provisório",
          legacy: "Nome existente protegido",
        },
        nameSourceHelp: {
          manual: "Nome digitado ou corrigido manualmente. O WhatsApp não irá substituí-lo.",
          whatsapp_verified: "Nome comercial ou verificado informado pelo WhatsApp.",
          whatsapp_profile: "Nome público configurado pela pessoa no perfil do WhatsApp.",
          whatsapp_address_book: "Nome salvo na agenda da conexão do WhatsApp.",
          provisional: "Nome provisório: normalmente é o número de telefone. Pode ser substituído quando o WhatsApp fornecer um nome melhor.",
          legacy: "Nome que já existia antes do registro de origem. É mantido para evitar alterações acidentais.",
        },
      },
      contactImport: {
        title: "Importar contatos do WhatsApp Business",
        description: "Selecione uma conexão, revise a prévia e escolha apenas os contatos que deseja importar. Nomes editados manualmente nunca serão substituídos.",
        connection: "Conexão do WhatsApp",
        loadPreview: "Carregar prévia",
        noConnections: "Não há conexões ativas do WhatsApp disponíveis.",
        search: "Pesquisar por nome ou número",
        statusFilter: "Status no Whaticket",
        sourceFilter: "Origem do nome",
        source: {
          all: "Todas as origens",
          addressBook: "Agenda salva",
          named: "Todos com nome",
          verified: "Comercial ou verificado",
          profile: "Perfil do WhatsApp",
          provisional: "Somente números / sem nome",
        },
        selectRecommended: "Selecionar recomendados",
        recommendedHelp: " Seleciona contatos novos e nomes provisórios que podem ser melhorados.",
        bulkPhotoWarning: " Seleções com mais de 100 contatos ignoram a consulta individual de fotos para evitar uma espera longa; as fotos existentes são preservadas.",
        rowsPerPage: "Linhas por página",
        duplicatesInSource: "{{count}} registros consolidados",
        protectedName: "O nome existente será mantido: {{name}}",
        status: {
          all: "Todos",
          new: "Novo",
          update: "Atualizar nome",
          existing: "Já existe",
          protected: "Nome protegido",
        },
        statusHelp: {
          all: "Mostra todos os contatos, independentemente da situação atual no Whaticket.",
          new: "O número está disponível no WhatsApp, mas ainda não existe como contato no Whaticket.",
          update: "O contato existe com um nome provisório e o WhatsApp encontrou um nome melhor.",
          existing: "O contato já existe no Whaticket e não precisa de alteração no nome.",
          protected: "O contato tem um nome manual ou anterior que o Whaticket preservará sem substituir.",
        },
        sourceHelp: {
          all: "Mostra os contatos sem limitar a origem do nome.",
          addressBook: "É o sinal mais confiável de que o contato está salvo na agenda vinculada a esta conexão.",
          named: "Mostra todos os contatos com nome, mesmo quando o nome pode não estar salvo na agenda.",
          verified: "O WhatsApp conhece publicamente o nome comercial; isso não garante que o operador o salvou.",
          profile: "A própria pessoa configurou este nome no perfil; ele pode não estar salvo na agenda.",
          provisional: "O WhatsApp forneceu apenas o número. Geralmente é uma conversa ocasional ou um contato sem nome disponível.",
        },
        summary: {
          available: "Disponíveis",
          new: "Novos",
          update: "Atualizáveis",
          existing: "Existentes",
          protected: "Protegidos",
          duplicates: "Duplicados unidos",
          skipped: "Grupos ou IDs ignorados",
        },
        summaryHelp: {
          available: "Total de telefones únicos utilizáveis. É a soma de Novos, Atualizáveis, Existentes e Protegidos; não é um grupo adicional.",
          new: "Telefones fornecidos pelo WhatsApp que ainda não existem como contatos no Whaticket.",
          update: "Contatos existentes cujo nome provisório pode ser substituído com segurança por um nome melhor.",
          existing: "Contatos que já existem e não precisam alterar o nome.",
          protected: "Contatos existentes com nome manual ou anterior que o Whaticket não substituirá.",
          duplicates: "Registros repetidos do mesmo telefone encontrados na conexão e unidos em uma única linha; contatos duplicados não serão criados.",
          skipped: "Grupos e identificadores internos LID usados pelo WhatsApp que não contêm um telefone importável. Um valor alto pode ser normal.",
        },
        table: {
          name: "Nome disponível",
          number: "Número",
          status: "Resultado previsto",
        },
        cancel: "Cancelar",
        close: "Fechar",
        importing: "Importando...",
        importSelected: "Importar selecionados ({{count}})",
        completed: "Importação de contatos concluída.",
        resultTitle: "Resultado da importação",
        result: "Criados: {{created}} · Atualizados: {{updated}} · Nomes protegidos: {{protected}} · Sem alterações: {{unchanged}} · Erros: {{errors}} · Fotos ignoradas na importação em massa: {{photosSkipped}}",
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          countryCode: "Código do país",
          number: "Número do Whatsapp",
          numberHint: "Digite o número sem o prefixo. Ele será salvo com o código do país selecionado.",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        attentionRequired: "Requer atenção",
        noAttentionPending: "Nenhum ticket precisa de atenção",
        attended: "Atendidos",
        internalTag: "Interna",
        closedTag: "Fechado",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        lastSender: {
          customer: "O cliente enviou a última mensagem",
          operator: "O operador enviou a última mensagem",
          unknown: "Não se sabe quem enviou a última mensagem",
        },
        buttons: {
          accept: "Aceitar",
          reject: "Rejeitar",
        },
        postpone: {
          button: "Adiar",
          activeUntil: "Adiado até {{date}}",
          fifteenMinutes: "15 minutos",
          thirtyMinutes: "30 minutos",
          oneHour: "1 hora",
          twoHours: "2 horas",
          tomorrow: "Até amanhã",
          more: "Mais tempo…",
          toastMessage: "Adiado {{label}}",
          undo: "Desfazer",
          undoSuccess: "Adiamento desfeito",
          customTitle: "Adiar por mais tempo",
          amountLabel: "Quantidade",
          unitLabel: "Unidade",
          units: {
            minutes: "Minutos",
            hours: "Horas",
            days: "Dias",
          },
          confirm: "Adiar",
          cancel: "Cancelar",
          invalidAmount: "Digite uma quantidade válida",
          noResponseNeeded: "Não precisa de resposta",
          noResponseSuccess: "Marcado como não precisa de resposta",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            notifications: "Som das notificações",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      notificationSound: {
        title: "Som das notificações",
        enabled: "Reproduzir som",
        enabledHelp: "Esta opção controla apenas o som do Whaticket neste navegador.",
        tone: "Toque",
        tones: {
          soft: "Suave (recomendado)",
          discreet: "Discreto",
          classic: "Atual",
        },
        volume: "Volume do Whaticket",
        repeatInterval: "Intervalo mínimo entre sons",
        intervals: {
          everyMessage: "Em cada mensagem",
        },
        seconds: "segundos",
        repeatHelp: "Se várias mensagens chegarem juntas, o aviso tocará no máximo uma vez durante este intervalo.",
        test: "Testar som",
        cancel: "Cancelar",
        save: "Salvar",
      },
      phoneConversation: {
        title: "Abrir conversa por número",
        help: "Revise o número e escolha qual conexão do WhatsApp atenderá a conversa.",
        number: "Número de telefone",
        countryCode: "Código do país",
        countryHelp: "Use 57 para a Colômbia. Se o número já incluir o país, ele não será duplicado.",
        name: "Nome do contato (opcional)",
        connection: "Enviar pela conexão",
        noConnections: "Não há conexões do WhatsApp ativas.",
        noAutomaticMessage: "O ticket será aberto, mas nenhuma mensagem será enviada automaticamente.",
        copy: "Copiar",
        copied: "Número copiado.",
        copyError: "Não foi possível copiar o número.",
        cancel: "Cancelar",
        start: "Abrir conversa",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          businessDayStartHour: {
            name: "Hora de início do expediente",
          },
          businessWorkingDays: {
            name: "Dias úteis",
            days: {
              0: "Dom",
              1: "Seg",
              2: "Ter",
              3: "Qua",
              4: "Qui",
              5: "Sex",
              6: "Sáb",
            },
          },
          oldTicketsReminder: {
            name: "Lembrete de tickets antigos",
            enabledLabel: "Ativar lembrete",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
            thresholdDaysLabel: "Dias sem atividade para considerar antigo",
            intervalMinutesLabel: "Intervalo entre lembretes (minutos)",
          },
          postReplySnooze: {
            name: "Adiar após responder",
            secondsLabel: "Tempo disponível (segundos, 0 desativa)",
          },
        },
      },
      oldTicketsReminder: {
        title: "Tickets abertos antigos",
        message:
          "Você tem {{count}} ticket aberto com mais de {{days}} dias sem atividade. Lembre-se de revisá-lo e encerrá-lo quando apropriado.",
        message_plural:
          "Você tem {{count}} tickets abertos com mais de {{days}} dias sem atividade. Lembre-se de revisá-los e encerrá-los quando apropriado.",
        accept: "OK",
      },
      messagesList: {
        download: "Baixar",
        downloading: "Baixando…",
        downloadError: "Não foi possível baixar o arquivo. Tente novamente.",
        history: {
          previousTicket: "Conversa anterior · ticket #{{ticketId}}",
          currentTicket: "Conversa atual · ticket #{{ticketId}}",
        },
        delivery: {
          pending: "Enviando ou aguardando confirmação do WhatsApp",
          failed: "Envio não confirmado. Verifique antes de enviar novamente",
        },
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            reject: "Rejeitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        sendImagesAsHd: "Enviar imagens em HD",
        sendImagesAsHdHelp: "Maior qualidade; o envio pode demorar um pouco mais.",
        mediaCaptionPlaceholder: "Adicionar uma legenda",
        sendContactCard: "Enviar contato",
        contactCardTitle: "Enviar cartão de contato",
        contactCardSearch: "Buscar por nome ou número",
        contactCardSend: "Enviar contato",
        contactCardCancel: "Cancelar",
        contactCardSent: "Cartão de contato enviado.",
        emojis: "Emojis",
        attachFiles: "Anexar arquivos",
        sendLocation: "Enviar localização",
        locationTitle: "Enviar localização",
        locationUseCurrent: "Usar minha localização atual",
        locationLocating: "Obtendo localização…",
        locationLatitude: "Latitude",
        locationLongitude: "Longitude",
        locationName: "Nome do local (opcional)",
        locationAddress: "Endereço (opcional)",
        locationHelp: "Você pode copiar as coordenadas do Google Maps.",
        locationPreview: "Localização selecionada",
        locationOpenMap: "Revisar mapa",
        locationSend: "Enviar localização",
        locationCancel: "Cancelar",
        locationSent: "Localização enviada.",
        locationUnavailable: "Este navegador não permite obter a localização.",
        locationPermissionError: "Não foi possível obter a localização. Verifique a permissão do navegador ou digite as coordenadas.",
      },
      contactDrawer: {
        header: "Dados do contato",
        phoneUnavailable: "O cliente não compartilhou o número de telefone",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      ticketMute: {
        title: "Silenciar conversa",
        description: "Escolha por quanto tempo o Whaticket não reproduzirá sons nem mostrará avisos na área de trabalho para esta conversa.",
        eightHours: "8 horas",
        oneWeek: "1 semana",
        forever: "Sempre",
        syncWarning: "O Whaticket tentará sincronizar esta alteração com o WhatsApp Business. Se o WhatsApp não aceitar, o silêncio continuará funcionando apenas no Whaticket.",
        cancel: "Cancelar",
        confirm: "Silenciar",
        mute: "Silenciar conversa",
        unmute: "Reativar notificações",
        muted: "Silenciada",
        synced: "Conversa silenciada no Whaticket e no WhatsApp.",
        localOnly: "Conversa silenciada apenas no Whaticket; o WhatsApp não confirmou a alteração.",
        unmutedSynced: "Notificações reativadas no Whaticket e no WhatsApp.",
        unmutedLocalOnly: "Notificações reativadas no Whaticket; o WhatsApp não confirmou a alteração.",
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        open: "Opções da mensagem",
        delete: "Deletar",
        forward: "Reenviar",
        reply: "Responder",
        react: "Reagir",
        pin: "Fixar mensagem",
        unpin: "Desafixar mensagem",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      messageReaction: {
        title: "Reagir à mensagem",
        remove: "Remover minha reação",
        cancel: "Cancelar",
      },
      messagePin: {
        title: "Fixar mensagem",
        description: "Escolha por quanto tempo a mensagem ficará fixada nesta conversa do WhatsApp.",
        oneDay: "24 horas",
        sevenDays: "7 dias",
        thirtyDays: "30 dias",
        cancel: "Cancelar",
        confirm: "Fixar",
        synced: "Mensagem fixada e sincronizada com o WhatsApp.",
        localOnly: "Mensagem fixada apenas no Whaticket; o WhatsApp não conseguiu sincronizá-la.",
        unpinnedSynced: "Mensagem desafixada no Whaticket e no WhatsApp.",
        unpinnedLocalOnly: "Mensagem desafixada no Whaticket; o WhatsApp não confirmou a alteração.",
      },
      pinnedMessages: {
        title: "Mensagens fixadas",
        pinned: "Mensagem fixada",
        until: "até",
        image: "Imagem",
        audio: "Áudio",
        video: "Vídeo",
        location: "Localização",
        contact: "Contato",
        message: "Mensagem",
        you: "Você",
        synced: "Sincronizado com o WhatsApp",
        localOnly: "Apenas no Whaticket",
      },
      forwardMessageModal: {
        title: "Reenviar mensagem",
        fieldLabel: "Buscar ticket de destino",
        noOptions: "Nenhum ticket disponível encontrado",
        ticketHint: "Pesquise por cliente, número, fila ou ticket.",
        queue: "Fila",
        channel: "Canal",
        assignedTo: "Responsável",
        unassigned: "Sem responsável",
        success: "Mensagem reenviada com sucesso.",
        buttons: {
          cancel: "Cancelar",
          ok: "Reenviar",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_REACT_WAPP_MSG: "Não foi possível reagir à mensagem do WhatsApp.",
        ERR_INVALID_REACTION: "A reação selecionada não é válida.",
        ERR_PIN_WAPP_MSG: "Não foi possível fixar ou desafixar a mensagem no WhatsApp.",
        ERR_PIN_NOT_SUPPORTED: "A conexão selecionada não permite fixar mensagens.",
        ERR_INVALID_PIN_DURATION: "O período selecionado para fixar a mensagem não é válido.",
        ERR_INVALID_PIN_REQUEST: "A solicitação para fixar a mensagem não é válida.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_MESSAGE_FOUND: "Nenhuma mensagem encontrada com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_INVALID_FORWARD_TARGET:
          "Selecione um ticket aberto ou pendente para reenviar a mensagem.",
        ERR_FORWARD_MEDIA_NOT_FOUND:
          "O arquivo original desta mídia não foi encontrado para reenviar.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_WAPP_INVALID_PROVIDER:
          "O método de conexão escolhido não é válido.",
      },
    },
  },
};

export { messages };
